module.exports = __webpack_public_path__ + "bank_order_en.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_order_en.png
// module id = 1868
// module chunks = 0